export const wordRegex = /[^0-9]/g; // g: 전역 검색
export const koreanRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
export const numRegex = /^[0-9]+$/;
export const idRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*)[A-Za-z\d]{6,12}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const pwdRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,20}$/;
export const phoneNumRegex = /^0[\d]{8,11}$/;
export const phoneRegex = /^(02|0[\d]{2,3})-\d{3,4}-\d{4}$/;

const stateType = process.env.REACT_APP_MODE_TYPE;
// export const baseURL = "http://210.113.122.196:8851";
const baseURL = stateType === "live" ? "http://tbell.co.kr" : "http://210.113.122.196:8851";

export const restPath = baseURL + "/rest/api/1";
export const staticURL = baseURL + "/static";
export const kakaoURL = restPath + "/auth/kakao/login";

export const KAKAO_JS_KEY = "f810dbffcc94c50036f8617a763b8a5e";

export const footerInfo = {
  phone: `070-7777-9113`,
  consulting: `staff@tbell.co.kr   |   월-금요일   09:30-18:00   |   점심시간   12:00-13:00`,
  info: `\n대표이사  :  김종균   |   사업자등록번호  :  376-81-00089\n`,
  contact: `Tel  :  070.7777.9113  /  070.7777.6368   |   Fax  :  070.7610.7540   |   E-mail  :  staff@tbell.co.kr\n\n`,
  address:
    `(강남본사) 서울특별시 강남구 강남대로 354, 9층\n` +
    `(가산지사) 서울특별시 금천구 가산디지털1로 168, A동 601호\n\n`,
  copy: `Copyright 2015-${new Date().getFullYear()}. TBELL Corp. All Rights Reserved.`,
};

export const policyInfo =
  `TBELL 개인정보이용 처리방침\n\n` +
  `주식회사 티벨은 고객들의 개인정보를 소중히 다루고 있습니다.\n\n` +
  `주식회사 티벨(이하, ‘티벨’이라 함)은 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법, 전기통신사업법 등 ` +
  `정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, ` +
  `관련 법령에 의거한 개인정보방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다. ` +
  `본 개인정보처리방침은 티벨이 제공하는 의뢰/문의 서비스에 한해 적용되며 다음과 같은 내용을 담고 있습니다.\n\n` +
  `1. 수집하는 개인정보의 항목 및 수집방법\n` +
  `2. 개인정보의 수집 및 이용목적\n` +
  `3. 개인정보의 보유 및 이용기간\n` +
  `4. 개인정보 파기절차 및 방법 수집하는 개인정보의 항목 및 수집방법\n` +
  `가. 수집하는 개인정보의 항목- 성명, 이메일, 전화번호, 회사명`;

export const personalPolicy =
  `개인정보 수집 동의 개인정보 수집 및 이용에 관한 안내\n`
  +`개인정보의 제공을 거부하실 수 있으시나, 거부하실 경우 상담에 제한이 있습니다.\n\n`
  +`1. 개인 정보의 수집ㆍ이용 목적\n`
  +`\t• 본인확인, 문의사항 전달, 혜택 안내, 견적 상담 \n`
  +`2. 수집하는 개인정보의 항목[필수]\n`
  +`\t• 기재하시는 이름 또는 회사명, 휴대전화 번호, 이메일 주소\n`
  +`3. 개인정보의 보유ㆍ이용 기간\n`
  +`\t• 승인하신 때로부터 2년`;